import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSChatMessagesCollection = GenericCollectionFactory("PMS_CHAT_MESSAGES", "uid")